import { useTranslation } from 'react-i18next';
import React, { useContext, useState, useEffect } from "react"
import TopSearch from "@/components/TopSearch"
import ListComponent from "@/components/listComponent"
import { getBussinessEntityList, bussinesEntityDelete } from "@/service/dataService"
import { MyContext } from "@/store/myContext"
import Detail from "./detail"
import { Modal, Select } from "antd"
import { getPcodeDict } from "@/utils/dataStorage"
const { Option } = Select

export default () => {
    
const { t } = useTranslation();
const { state, message } = useContext(MyContext)
    const [showVisible, setShowVisible] = useState(false)
    const [showMode, setShowMode] = useState("")
    const [list, setList] = useState([]) //列表
    const [searchValue, setSearchValue] = useState({})
    const [pagination, setpagination] = useState({
        //分页配置
        total: 0,
        current: 1,
        pageSize: 10,
    })
    const [selectInfo, setSelectInfo] = useState({ rowInfo: {}, rowIndex: -1 }) //记录当前行下标及信息

    useEffect(() => {
        if (state.activeMenu === "entity") {
            loadData(pagination.current)
        }
    }, [state.activeMenu])// eslint-disable-line react-hooks/exhaustive-deps

    //列表数据
    const loadData = (current, search = {}) => {
        let data = {
            searchItem: { ...search },
            pageNum: current,
            pageSize: 10,
            orders: [
                {
                    column: "updateTime",
                    rule: "DESC",
                },
            ],
        }
        getBussinessEntityList(data).then((res) => {
            setpagination({
                current: current,
                total: res.retData.total,
                pageSize: 10,
            })
            setSelectInfo({ rowInfo: {}, rowIndex: -1 })
            setList(res.retData.list)
        })
    }
    //分页事件 置空当前行信息
    const onTableChange = async (page) => {
        await setpagination({
            ...pagination,
            current: page.current,
        })
        loadData(page.current, searchValue)
    }

    //列表button
    const topButtons = [
        {
            click: () => handleDetails("insert"),
            content: t(`dataManage.entity.index.新增`),
        },
        {
            click: () => handleDetails("edit"),
            content: t(`dataManage.entity.index.编辑`),
        },
        {
            click: () => handleDelete(),
            content: t(`dataManage.entity.index.删除`),
        },
    ]

    //删除
    const handleDelete = async () => {
        if (!Object.keys(selectInfo.rowInfo).length) {
            message.warning(t(`dataManage.entity.index.请选择你要删除的所属实体信息`))
            return
        }
        const modal = Modal.confirm({
            content: `${t(`dataManage.entity.index.确定要删除所属实体`)}--${selectInfo.rowInfo.entityName}?`,
            okText: t(`dataManage.entity.index.确定`),
            cancelText: t(`dataManage.entity.index.取消`),
            centered: true,
            onOk() {
                bussinesEntityDelete(selectInfo.rowInfo.id).then((res) => {
                    message.success(t(`dataManage.entity.index.删除成功`))
                    loadData(pagination.current, searchValue)
                })
            },
        })
    }
    //新增
    const handleDetails = async (mode) => {
        if (mode === "edit") {
            if (!Object.keys(selectInfo.rowInfo).length) {
                message.warning(t(`dataManage.entity.index.请选择你要编辑的所属实体`))
                return
            }
        } else if (mode === "look") {
            if (!Object.keys(selectInfo.rowInfo).length) {
                message.warning(t(`dataManage.entity.index.请选择你要查看的所属实体`))
                return
            }
        }
        setShowMode(mode)
        setShowVisible(true)
    }


    //table配置
    const columns = [
        {
            title: t(`dataManage.entity.index.实体名称`),
            align: "center",
            dataIndex: "entityName",
        },
        {
            title: t(`dataManage.entity.index.统一信用编码`),
            align: "center",
            dataIndex: "entityCreditCode",
        },
        // {
        //     title: "法人",
        //     align: "center",
        //     dataIndex: "legalPerson",
        // },
        {
            title: t(`dataManage.entity.index.三包名称`),
            align: "center",
            dataIndex: "threeGuaranteesName",
        },
        {
            title: t(`dataManage.entity.index.联系电话`),
            align: "center",
            dataIndex: "contactPhone",
        },
    ]
    //搜索JSON
    const searchList = {
        normalList: [
            {
                type: "input",
                placeholder: t(`dataManage.entity.index.请输入实体名称`),
                valueName: "entityName",
            },
            {
                type: "select",
                placeholder: t(`dataManage.entity.index.请选择三包品牌`),
                valueName: "threeGuarantees",
                optionList: () =>
                    getPcodeDict("106").children.map((item) => (
                        <Option value={item.dictCode} key={item.id}>
                            {item.title}
                        </Option>
                    )),
            },
        ],
    }

    return (
        <>
            {state.activeMenu === "entity" && (
                <>
                    <TopSearch
                        title= {t(`dataManage.entity.index.所属实体`)}
                        searchListData={searchList}
                        searchValue={searchValue}
                        setSearchValue={(obj) => setSearchValue(obj)}
                        handleSearch={loadData}
                    />
                    <ListComponent
                        title= {t(`dataManage.entity.index.所属实体`)}
                        buttons={topButtons}
                        selectInfo={selectInfo}
                        columns={columns}
                        dataSource={list}
                        pagination={pagination}
                        onTableChange={onTableChange}
                        scroll={{ x: "max-content" }}
                        setSelectInfo={(obj) => setSelectInfo(obj)}
                    />

                    {showVisible && (
                        <Detail
                            rowInfo={selectInfo.rowInfo}
                            visible={showVisible}
                            mode={showMode}
                            setVisible={setShowVisible}
                            onSuccess={() => {
                                loadData(1, searchValue)
                            }}
                        />
                    )}
                </>
            )}
        </>
    )
}
